import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  h2 as emptyList,
  a1 as Unit_getInstance,
  e1 as ArrayList,
  a2 as collectionSizeOrDefault,
  f2 as copyToArray,
  p5 as classMeta,
  z5 as interfaceMeta,
  r9 as RuntimeException,
  s9 as THROW_CCE,
  g6 as isObject,
  n5 as charSequenceLength,
  y9 as ensureNotNull,
  b3 as listOf,
  s3 as plus,
  d3 as mapCapacity,
  u6 as coerceAtLeast,
  j1 as LinkedHashMap,
  q9 as Pair,
  h4 as toMutableMap,
  s5 as equals,
  e6 as isInterface,
  t1 as Set,
  aa as noWhenBranchMatchedException,
  t2 as joinToString,
  o9 as NotImplementedError,
  z1 as checkIndexOverflow,
  c4 as toList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  e as LogLevel_Debug_getInstance,
  f as LogLevel_Error_getInstance,
} from './net.akehurst.language.editor-agl-editor-api.mjs';
import {
  h as Agl_getInstance,
  v7 as AglStyleSelector,
  c as AglStyleSelectorKind_LITERAL_getInstance,
  s7 as AglStyleRule,
  w7 as AglStyle,
  l7 as SentenceContext,
} from './net.akehurst.language-agl-processor.mjs';
import {
  u as AglEditorJsAbstract,
  d as Companion_getInstance,
  y as AglTokenizer,
  v as AglLineState,
  x as AglTokenizerByWorker,
} from './net.akehurst.language.editor-agl-editor-common.mjs';
import {
  b as removeClass,
  a as addClass,
} from './kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class BuildConfig_0 {
  constructor() {
    BuildConfig_instance = this;
    this.version = '1.9.20-Beta';
    this.buildStamp = '2023-09-29T11:11:46.81887Z[UTC]';
    this.buildDate = '2023-Sept-29';
    this.buildTime = '11:11:46 UTC';
  }
  nt() {
    return this.version;
  }
  ot() {
    return this.buildStamp;
  }
  pt() {
    return this.buildDate;
  }
  qt() {
    return this.buildTime;
  }
}
class AglCodeCompleter {
  constructor(agl, aglWorker) {
    this.agl = agl;
    this.aglWorker = aglWorker;
  }
  c25() {
    return this.agl;
  }
  i4r() {
    return this.aglWorker;
  }
  getCompletions(editor, session, pos, prefix, callback) {
    var posn = session.getDocument().positionToIndex(pos, 0);
    var wordList = getCompletionItems(this, editor, posn);
    var tmp$ret$4;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(wordList, 10));
    var tmp0_iterator = wordList.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$1;
      // Inline function 'net.akehurst.language.editor.browser.ace.AglCodeCompleter.getCompletions.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.editor.common.objectJS' call
      var o = {};
      // Inline function 'net.akehurst.language.editor.browser.ace.AglCodeCompleter.getCompletions.<anonymous>.<anonymous>' call
      o.caption = item.text;
      o.value = item.text;
      o.meta = '(' + item.name + ')';
      tmp$ret$0 = o;
      tmp$ret$1 = tmp$ret$0;
      tmp0_mapTo.e1(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    var tmp0_toTypedArray = tmp$ret$3;
    tmp$ret$4 = copyToArray(tmp0_toTypedArray);
    var aceCi = tmp$ret$4;
    callback(null, aceCi);
  }
}
class AglCodeCompleterByWorker {
  constructor(agl) {
    this.agl = agl;
  }
  c25() {
    return this.agl;
  }
  getCompletions(editor, session, pos, prefix, callback) {
    var posn = session.getDocument().positionToIndex(pos, 0);
    var wordList = getCompletionItems_0(this, editor, posn);
    var tmp$ret$4;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(wordList, 10));
    var tmp0_iterator = wordList.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$1;
      // Inline function 'net.akehurst.language.editor.browser.ace.AglCodeCompleterByWorker.getCompletions.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.editor.common.objectJS' call
      var o = {};
      // Inline function 'net.akehurst.language.editor.browser.ace.AglCodeCompleterByWorker.getCompletions.<anonymous>.<anonymous>' call
      o.caption = item.text;
      o.value = item.text;
      o.meta = '(' + item.name + ')';
      tmp$ret$0 = o;
      tmp$ret$1 = tmp$ret$0;
      tmp0_mapTo.e1(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    var tmp0_toTypedArray = tmp$ret$3;
    tmp$ret$4 = copyToArray(tmp0_toTypedArray);
    var aceCi = tmp$ret$4;
    callback(null, aceCi);
  }
}
class AglErrorAnnotation {
  constructor(line, column, text, type, raw) {
    this.line = line;
    this.column = column;
    this.text = text;
    this.type = type;
    this.raw = raw;
    this.row = this.line - 1 | 0;
  }
  v2j() {
    return this.line;
  }
  u2j() {
    return this.column;
  }
  u1p() {
    return this.text;
  }
  em() {
    return this.type;
  }
  s4s() {
    return this.raw;
  }
  t4s() {
    return this.row;
  }
}
class IAce {}
class AglEditorAce extends AglEditorJsAbstract {
  constructor(containerElement, aceEditor, languageId, editorId, logFunction, worker, ace) {
    super(languageId, editorId, logFunction, worker);
    this.a4t_1 = containerElement;
    this.b4t_1 = aceEditor;
    this.c4t_1 = ace;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.d4t_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_0.e4t_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$2 = ArrayList.i4();
    tmp_1.f4t_1 = tmp$ret$2;
    this.g4t_1 = null;
    this.h4t();
  }
  x4c() {
    return this.b4t_1;
  }
  k4n() {
    var tmp0_safe_receiver = this.b4t_1.getSession();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id;
    return tmp1_elvis_lhs == null ? 'none' : tmp1_elvis_lhs;
  }
  g4d(value) {
    try {
      this.b4t_1.setValue(value, -1);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        throw RuntimeException.u6('Failed to set text in editor');
      } else {
        throw $p;
      }
    }
  }
  u1p() {
    try {
      return this.b4t_1.getValue();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        throw RuntimeException.u6('Failed to get text from editor');
      } else {
        throw $p;
      }
    }
  }
  h4t() {
    this.connectWorker(new AglTokenizerByWorkerAce(this.agl));
    var tmp0_safe_receiver = this.b4t_1.getSession();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bgTokenizer;
    if (tmp1_safe_receiver == null) {
    } else {
      var tmp = this.workerTokenizer;
      tmp1_safe_receiver.tokenizer = isObject(tmp) ? tmp : THROW_CCE();
    }
    var tmp3_safe_receiver = this.b4t_1.getSession();
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.bgTokenizer;
    if (tmp4_safe_receiver == null)
      null;
    else {
      var tmp2_safe_receiver = this.b4t_1.getSession();
      tmp4_safe_receiver.setDocument(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.getDocument());
    }
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [new AglCodeCompleter(this.agl, this.aglWorker)];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    this.b4t_1.completers = tmp$ret$2;
    this.b4t_1.on('change', AglEditorAce$init_$lambda(this));
    var resizeObserver = new ResizeObserver(AglEditorAce$init_$lambda_0(this));
    resizeObserver.observe(this.a4t_1);
    this.updateLanguage(null);
    this.updateProcessor();
    this.updateStyle();
  }
  destroy() {
    this.b4t_1.destroy();
  }
  configureSyntaxAnalyser(configuration) {
    var tmp0_safe_receiver = this.b4t_1.getSession();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.configureSyntaxAnalyser.<anonymous>' call
      this.aglWorker.configureSyntaxAnalyser(this.languageIdentity, this.editorId, tmp0_safe_receiver.id, configuration);
      tmp$ret$0 = tmp0_safe_receiver;
    }
  }
  updateLanguage(oldId) {
    if (!(null == oldId)) {
      var oldAglStyleClass = Companion_getInstance().languageIdToStyleClass(this.agl.styleHandler.cssClassPrefixStart, oldId);
      removeClass(this.a4t_1, [oldAglStyleClass]);
    }
    addClass(this.a4t_1, [this.agl.styleHandler.aglStyleClass]);
  }
  updateStyle() {
    if (this.a4t_1.isConnected) {
      var tmp0_safe_receiver = this.b4t_1.getSession();
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$7;
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.updateStyle.<anonymous>' call
        var aglStyleClass = this.agl.styleHandler.aglStyleClass;
        var str = this.editorSpecificStyleStr;
        var tmp;
        if (!(null == str)) {
          var tmp$ret$0;
          // Inline function 'kotlin.text.isNotEmpty' call
          tmp$ret$0 = charSequenceLength(str) > 0;
          tmp = tmp$ret$0;
        } else {
          tmp = false;
        }
        if (tmp) {
          this.agl.styleHandler.reset();
          var styleMdl = ensureNotNull(Agl_getInstance().registry.agl.style.processor).process(str).asm;
          if (!(null == styleMdl)) {
            var mappedCss = '';
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_forEach = styleMdl.rules;
            var tmp0_iterator = tmp0_forEach.u();
            while (tmp0_iterator.h1()) {
              var element = tmp0_iterator.j1();
              // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.updateStyle.<anonymous>.<anonymous>' call
              var tmp$ret$3;
              // Inline function 'kotlin.collections.map' call
              var tmp0_map = element.selector;
              var tmp$ret$2;
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
              var tmp0_iterator_0 = tmp0_map.u();
              while (tmp0_iterator_0.h1()) {
                var item = tmp0_iterator_0.j1();
                var tmp$ret$1;
                // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.updateStyle.<anonymous>.<anonymous>.<anonymous>' call
                var mappedSelName = this.agl.styleHandler.mapClass(item.value);
                tmp$ret$1 = new AglStyleSelector('.ace_' + mappedSelName, item.kind);
                tmp0_mapTo.e1(tmp$ret$1);
              }
              tmp$ret$2 = tmp0_mapTo;
              tmp$ret$3 = tmp$ret$2;
              var ruleClasses = tmp$ret$3;
              var cssClasses = plus(listOf(new AglStyleSelector('.' + aglStyleClass, AglStyleSelectorKind_LITERAL_getInstance())), ruleClasses);
              var mappedRule = new AglStyleRule(cssClasses);
              var tmp_0 = mappedRule;
              var tmp$ret$6;
              // Inline function 'kotlin.collections.associate' call
              var tmp1_associate = element.styles.k3();
              var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associate, 10)), 16);
              var tmp$ret$5;
              // Inline function 'kotlin.collections.associateTo' call
              var tmp0_associateTo = LinkedHashMap.o8(capacity);
              var tmp0_iterator_1 = tmp1_associate.u();
              while (tmp0_iterator_1.h1()) {
                var element_0 = tmp0_iterator_1.j1();
                // Inline function 'kotlin.collections.plusAssign' call
                var tmp$ret$4;
                // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.updateStyle.<anonymous>.<anonymous>.<anonymous>' call
                var tmp0_subject = element_0.name;
                var tmp_1;
                switch (tmp0_subject) {
                  case 'foreground':
                    tmp_1 = new AglStyle('color', element_0.value);
                    break;
                  case 'background':
                    tmp_1 = new AglStyle('background-color', element_0.value);
                    break;
                  case 'font-style':
                    var tmp1_subject = element_0.value;
                    switch (tmp1_subject) {
                      case 'bold':
                        tmp_1 = new AglStyle('font-weight', element_0.value);
                        break;
                      case 'italic':
                        tmp_1 = new AglStyle('font-style', element_0.value);
                        break;
                      default:
                        tmp_1 = element_0;
                        break;
                    }

                    break;
                  default:
                    tmp_1 = element_0;
                    break;
                }
                var style = tmp_1;
                tmp$ret$4 = new Pair(style.name, style);
                var tmp0_plusAssign = tmp$ret$4;
                tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
              }
              tmp$ret$5 = tmp0_associateTo;
              tmp$ret$6 = tmp$ret$5;
              tmp_0.styles = toMutableMap(tmp$ret$6);
              mappedCss = mappedCss + '\n' + mappedRule.toCss();
            }
            var tmp_2 = this.a4t_1.getRootNode();
            var root = isObject(tmp_2) ? tmp_2 : THROW_CCE();
            if (!(null == root)) {
              var curStyle = root.querySelector('style#' + aglStyleClass);
              if (null == curStyle) {
                curStyle = ensureNotNull(this.a4t_1.ownerDocument).createElement('style');
                curStyle.id = aglStyleClass;
                if (equals(root, curStyle.ownerDocument)) {
                  ensureNotNull(ensureNotNull(curStyle.ownerDocument).head).prepend(curStyle);
                } else {
                  root.prepend(curStyle);
                }
              }
              curStyle.textContent = mappedCss;
            }
            this.aglWorker.setStyle(this.languageIdentity, this.editorId, tmp0_safe_receiver.id, str);
            update(this);
            this.resetTokenization();
          } else {
          }
        }
        tmp$ret$7 = tmp0_safe_receiver;
      }
    }
  }
  resetTokenization() {
    this.b4t_1.renderer.updateText();
    var sess = this.b4t_1.getSession();
    if (null == sess) {
      this.log(LogLevel_Error_getInstance(), 'session is null ??', null);
    } else {
      var bgt = sess.bgTokenizer;
      if (null == bgt) {
        this.log(LogLevel_Error_getInstance(), 'bgTokenizer is null ??', null);
      } else {
        bgt.start(0);
      }
    }
  }
  processSentence() {
    if (this.doUpdate) {
      this.clearErrorMarkers();
      var tmp0_safe_receiver = this.b4t_1.getSession();
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$0;
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.processSentence.<anonymous>' call
        this.aglWorker.interrupt(this.languageIdentity, this.editorId, tmp0_safe_receiver.id);
        var tmp = this.aglWorker;
        var tmp_0 = this.languageIdentity;
        var tmp_1 = tmp0_safe_receiver.id;
        var tmp_2 = this.agl.goalRule;
        var tmp_3 = this.u1p();
        var tmp_4 = this.agl.context;
        tmp.processSentence(tmp_0, this.editorId, tmp_1, tmp_2, tmp_3, (tmp_4 == null ? true : isInterface(tmp_4, SentenceContext)) ? tmp_4 : THROW_CCE());
        tmp$ret$0 = tmp0_safe_receiver;
      }
    }
  }
  clearErrorMarkers() {
    this.f4t_1.n1();
    var tmp0_safe_receiver = this.b4t_1.getSession();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.clearAnnotations();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.d4t_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.clearErrorMarkers.<anonymous>' call
      var tmp0_safe_receiver_0 = this.b4t_1.getSession();
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.removeMarker(element);
      }
    }
  }
  createIssueMarkers(issues) {
    var tmp$ret$8;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp$ret$7;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = issues.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$5;
      // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.createIssueMarkers.<anonymous>' call
      var tmp0_safe_receiver = element.location;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.createIssueMarkers.<anonymous>.<anonymous>' call
        tmp$ret$0 = tmp0_safe_receiver.column - 1 | 0;
        tmp$ret$1 = tmp$ret$0;
        tmp = tmp$ret$1;
      }
      var tmp1_elvis_lhs = tmp;
      var aceColumn = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var errMsg = null;
      var tmp2_subject = element.phase;
      var tmp0 = tmp2_subject.bc_1;
      switch (tmp0) {
        case 0:
          ;
          break;
        case 1:
          var tmp_0 = element.data;
          var expected = (tmp_0 == null ? true : isInterface(tmp_0, Set)) ? tmp_0 : THROW_CCE();
          errMsg = null == expected ? 'Syntax Error' : expected.y() ? 'Syntax Error' : 1 === expected.o() ? 'Syntax Error, expected: ' + expected : 'Syntax Error, expected one of: ' + expected;
          break;
        case 2:
          errMsg = 'Error ' + element.message;
          break;
        case 3:
          errMsg = 'Error ' + element.message;
          break;
        case 6:
          errMsg = 'Error ' + element.message;
          break;
        case 4:
          errMsg = 'Error ' + element.message;
          break;
        case 5:
          errMsg = 'Error ' + element.message;
          break;
        case 7:
          errMsg = 'Error ' + element.message;
          break;
      }
      var tmp_1;
      if (!(null == errMsg)) {
        var tmp3_subject = element.kind;
        var tmp0_0 = tmp3_subject.bc_1;
        var tmp_2;
        switch (tmp0_0) {
          case 0:
            tmp_2 = 'error';
            break;
          case 1:
            tmp_2 = 'warning';
            break;
          case 2:
            tmp_2 = 'information';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var errType = tmp_2;
        var tmp$ret$4;
        // Inline function 'net.akehurst.language.editor.common.objectJSTyped' call
        var o = {};
        // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.createIssueMarkers.<anonymous>.<anonymous>' call
        var tmp0_anonymous = o;
        var tmp0_safe_receiver_0 = element.location;
        var tmp_3;
        if (tmp0_safe_receiver_0 == null) {
          tmp_3 = null;
        } else {
          var tmp$ret$3;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp$ret$2;
          // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.createIssueMarkers.<anonymous>.<anonymous>.<anonymous>' call
          tmp$ret$2 = tmp0_safe_receiver_0.line - 1 | 0;
          tmp$ret$3 = tmp$ret$2;
          tmp_3 = tmp$ret$3;
        }
        var tmp1_elvis_lhs_0 = tmp_3;
        tmp0_anonymous.row = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
        tmp0_anonymous.column = aceColumn;
        tmp0_anonymous.text = errMsg;
        tmp0_anonymous.type = errType;
        tmp0_anonymous.raw = null;
        tmp$ret$4 = o;
        tmp_1 = tmp$ret$4;
      } else {
        tmp_1 = null;
      }
      tmp$ret$5 = tmp_1;
      var tmp0_safe_receiver_1 = tmp$ret$5;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        var tmp$ret$6;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver_1);
        tmp$ret$6 = Unit_getInstance();
      }
    }
    tmp$ret$7 = tmp0_mapNotNullTo;
    tmp$ret$8 = tmp$ret$7;
    var aceIssues = tmp$ret$8;
    this.f4t_1.k1(aceIssues);
    var tmp0_safe_receiver_2 = this.b4t_1.getSession();
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      var tmp$ret$9;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp0_toTypedArray = this.f4t_1;
      tmp$ret$9 = copyToArray(tmp0_toTypedArray);
      tmp0_safe_receiver_2.setAnnotations(tmp$ret$9);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = issues.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.createIssueMarkers.<anonymous>' call
      var tmp0_subject = element_0.kind;
      var tmp0_1 = tmp0_subject.bc_1;
      var tmp_4;
      switch (tmp0_1) {
        case 0:
          tmp_4 = 'error';
          break;
        case 1:
          tmp_4 = 'warning';
          break;
        case 2:
          tmp_4 = 'information';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var errType_0 = tmp_4;
      var tmp1_safe_receiver = element_0.location;
      var tmp_5;
      if (tmp1_safe_receiver == null) {
        tmp_5 = null;
      } else {
        var tmp$ret$11;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$10;
        // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.createIssueMarkers.<anonymous>.<anonymous>' call
        tmp$ret$10 = tmp1_safe_receiver.line - 1 | 0;
        tmp$ret$11 = tmp$ret$10;
        tmp_5 = tmp$ret$11;
      }
      var tmp2_elvis_lhs = tmp_5;
      var row = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      var tmp3_safe_receiver = element_0.location;
      var tmp_6;
      if (tmp3_safe_receiver == null) {
        tmp_6 = null;
      } else {
        var tmp$ret$13;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$12;
        // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.createIssueMarkers.<anonymous>.<anonymous>' call
        tmp$ret$12 = tmp3_safe_receiver.column - 1 | 0;
        tmp$ret$13 = tmp$ret$12;
        tmp_6 = tmp$ret$13;
      }
      var tmp4_elvis_lhs = tmp_6;
      var startColumn = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_safe_receiver = element_0.location;
      var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.length;
      var endColumn = startColumn + (tmp6_elvis_lhs == null ? 1 : tmp6_elvis_lhs) | 0;
      var range = this.c4t_1.createRange(row, startColumn, row, endColumn);
      var cls = 'ace_marker_text_' + errType_0;
      var tmp7_safe_receiver = this.b4t_1.getSession();
      var errMrkId = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.addMarker(range, cls, 'text');
      if (!(null == errMrkId)) {
        this.d4t_1.e1(errMrkId);
      }
    }
  }
}
class AglLineStateAce {
  constructor(lineNumber, leftOverText) {
    this.lineNumber = lineNumber;
    this.leftOverText = leftOverText;
  }
  v4n() {
    return this.lineNumber;
  }
  w4n() {
    return this.leftOverText;
  }
}
class AglTokenAce {
  constructor(styles, value, line, column) {
    this.i4t_1 = value;
    this.j4t_1 = line;
    this.k4t_1 = joinToString(styles, '.');
    this.l4t_1 = column;
  }
  p3() {
    return this.i4t_1;
  }
  v2j() {
    return this.j4t_1;
  }
  em() {
    return this.k4t_1;
  }
  m4t(_set____db54di) {
    this.l4t_1 = _set____db54di;
  }
  ub() {
    return this.l4t_1;
  }
  get value() {
    return this.p3();
  }
  get line() {
    return this.v2j();
  }
  get type() {
    return this.em();
  }
  get start() {
    return this.ub();
  }
  set start(value) {
    this.m4t(value);
  }
}
class AglLineTokensAce {
  constructor(state, tokens) {
    this.n4t_1 = state;
    this.o4t_1 = tokens;
  }
  e1s() {
    return this.n4t_1;
  }
  x4n() {
    return this.o4t_1;
  }
  get state() {
    return this.e1s();
  }
  get tokens() {
    return this.x4n();
  }
}
class AglTokenizerAce {
  constructor(agl, aglStyleHandler) {
    this.agl = agl;
    this.aglStyleHandler = aglStyleHandler;
    this.aglTokenizer = new AglTokenizer(this.agl);
  }
  c25() {
    return this.agl;
  }
  p4t() {
    return this.aglStyleHandler;
  }
  q4t() {
    return this.aglTokenizer;
  }
  r4t(line, state, row) {
    var sppt = this.agl.sppt;
    var tmp;
    if (null == state) {
      tmp = new AglLineStateAce(0, '');
    } else {
      tmp = state instanceof AglLineStateAce ? state : THROW_CCE();
    }
    var state2 = tmp;
    var tmp_0;
    if (null == sppt) {
      tmp_0 = this.getLineTokensByScan(line, state2, row);
    } else {
      tmp_0 = this.getLineTokensByParse(line, state2, row);
    }
    return tmp_0;
  }
  getLineTokens(line, state, row) {
    return this.r4t(line, state, row);
  }
  getLineTokensByScan(line, state, row) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg();
  }
  getLineTokensByParse(line, state, row) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg();
  }
}
class AglTokenizerByWorkerAce {
  constructor(agl) {
    this.aglTokenizer = new AglTokenizer(agl);
    this.s4t_1 = false;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.t4t_1 = tmp$ret$0;
  }
  q4t() {
    return this.aglTokenizer;
  }
  s4n(_set____db54di) {
    this.s4t_1 = _set____db54di;
  }
  t4n() {
    return this.s4t_1;
  }
  u4n() {
    return this.t4t_1;
  }
  reset() {
    this.s4t_1 = false;
    this.t4t_1.n1();
  }
  receiveTokens(lineTokens) {
    if (this.s4t_1) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = lineTokens.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.editor.browser.ace.AglTokenizerByWorkerAce.receiveTokens.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var tmp0_anonymous = checkIndexOverflow(tmp1);
        var tmp$ret$0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp$ret$0 = !item.y();
        if (tmp$ret$0) {
          // Inline function 'kotlin.collections.set' call
          var tmp0_set = this.t4t_1;
          var tmp1_set = toList(item);
          tmp0_set.m3(tmp0_anonymous, tmp1_set);
        } else {
        }
      }
    }
  }
  r4t(line, pState, row) {
    var tokens = this.t4t_1.u3(row);
    var tmp;
    if (null == tokens) {
      var tmp_0;
      if (null == pState) {
        tmp_0 = new AglLineStateAce(row, '');
      } else {
        tmp_0 = pState instanceof AglLineStateAce ? pState : THROW_CCE();
      }
      var aceState = tmp_0;
      var stateAgl = new AglLineState(aceState.lineNumber, aceState.leftOverText, emptyList());
      var ltokens = this.aglTokenizer.getLineTokensByScan(line, stateAgl, row);
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = ltokens.tokens;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator = tmp0_map.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.editor.browser.ace.AglTokenizerByWorkerAce.getLineTokens.<anonymous>' call
        tmp$ret$0 = new AglTokenAce(item.styles, item.value, item.line, item.column);
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var lineTokens = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp$ret$3 = copyToArray(lineTokens);
      var lt = tmp$ret$3;
      tmp = new AglLineTokensAce(new AglLineStateAce(row, ''), lt);
    } else {
      var tmp$ret$6;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$5;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tokens, 10));
      var tmp0_iterator_0 = tokens.u();
      while (tmp0_iterator_0.h1()) {
        var item_0 = tmp0_iterator_0.j1();
        var tmp$ret$4;
        // Inline function 'net.akehurst.language.editor.browser.ace.AglTokenizerByWorkerAce.getLineTokens.<anonymous>' call
        tmp$ret$4 = new AglTokenAce(item_0.styles, item_0.value, item_0.line, item_0.column);
        tmp0_mapTo_0.e1(tmp$ret$4);
      }
      tmp$ret$5 = tmp0_mapTo_0;
      tmp$ret$6 = tmp$ret$5;
      var lineTokens_0 = tmp$ret$6;
      var tmp$ret$7;
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp$ret$7 = copyToArray(lineTokens_0);
      var lt_0 = tmp$ret$7;
      tmp = new AglLineTokensAce(new AglLineStateAce(row, ''), lt_0);
    }
    return tmp;
  }
  getLineTokens(line, state, row) {
    return this.r4t(line, state, row);
  }
  get acceptingTokens() {
    return this.t4n();
  }
  set acceptingTokens(value) {
    this.s4n(value);
  }
  get tokensByLine() {
    return this.u4n();
  }
}
//endregion
var BuildConfig_instance;
function BuildConfig_getInstance() {
  if (BuildConfig_instance === VOID)
    new BuildConfig_0();
  return BuildConfig_instance;
}
function getCompletionItems($this, editor, pos) {
  var proc = $this.agl.languageDefinition.processor;
  var tmp;
  if (!(null == proc)) {
    var goalRule = $this.agl.goalRule;
    var context = $this.agl.context;
    if (null == context) {
      $this.agl.logger.log(LogLevel_Debug_getInstance(), 'context is null for code completion.', null);
    }
    var tmp_0 = editor.getValue();
    var tmp_1 = Agl_getInstance();
    var result = proc.expectedItemsAt(tmp_0, pos, 1, tmp_1.options(AglCodeCompleter$getCompletionItems$lambda(goalRule, context)));
    tmp = result.items;
  } else {
    tmp = emptyList();
  }
  return tmp;
}
function AglCodeCompleter$getCompletionItems$lambda$lambda($goalRule) {
  return function ($this$parse) {
    $this$parse.goalRuleName($goalRule);
    return Unit_getInstance();
  };
}
function AglCodeCompleter$getCompletionItems$lambda$lambda_0($context) {
  return function ($this$completionProvider) {
    $this$completionProvider.context($context);
    return Unit_getInstance();
  };
}
function AglCodeCompleter$getCompletionItems$lambda($goalRule, $context) {
  return function ($this$options) {
    $this$options.parse(AglCodeCompleter$getCompletionItems$lambda$lambda($goalRule));
    $this$options.completionProvider(AglCodeCompleter$getCompletionItems$lambda$lambda_0($context));
    return Unit_getInstance();
  };
}
function getCompletionItems_0($this, editor, pos) {
  var proc = $this.agl.languageDefinition.processor;
  var tmp;
  if (!(null == proc)) {
    var goalRule = $this.agl.goalRule;
    var context = $this.agl.context;
    if (null == context) {
      $this.agl.logger.log(LogLevel_Debug_getInstance(), 'context is null for code completion.', null);
    }
    var tmp_0 = editor.getValue();
    var tmp_1 = Agl_getInstance();
    var result = proc.expectedItemsAt(tmp_0, pos, 1, tmp_1.options(AglCodeCompleterByWorker$getCompletionItems$lambda(goalRule, context)));
    tmp = result.items;
  } else {
    tmp = emptyList();
  }
  return tmp;
}
function AglCodeCompleterByWorker$getCompletionItems$lambda$lambda($goalRule) {
  return function ($this$parse) {
    $this$parse.goalRuleName($goalRule);
    return Unit_getInstance();
  };
}
function AglCodeCompleterByWorker$getCompletionItems$lambda$lambda_0($context) {
  return function ($this$completionProvider) {
    $this$completionProvider.context($context);
    return Unit_getInstance();
  };
}
function AglCodeCompleterByWorker$getCompletionItems$lambda($goalRule, $context) {
  return function ($this$options) {
    $this$options.parse(AglCodeCompleterByWorker$getCompletionItems$lambda$lambda($goalRule));
    $this$options.completionProvider(AglCodeCompleterByWorker$getCompletionItems$lambda$lambda_0($context));
    return Unit_getInstance();
  };
}
function attachToAce(_this__u8e3s4, containerElement, aceEditor, languageId, editorId, logFunction, worker, ace) {
  return new AglEditorAce(containerElement, aceEditor, languageId, editorId, logFunction, worker, ace);
}
function update($this) {
  if ($this.doUpdate) {
    $this.workerTokenizer.reset();
    window.clearTimeout($this.g4t_1);
    var tmp = $this;
    var tmp_0 = window;
    tmp.g4t_1 = tmp_0.setTimeout(AglEditorAce$update$lambda($this), 500);
  }
}
function onResize($this, entries) {
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = entries.length;
  while (inductionVariable < last) {
    var element = entries[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'net.akehurst.language.editor.browser.ace.AglEditorAce.onResize.<anonymous>' call
    if (element.target == $this.a4t_1) {
      $this.b4t_1.resize(true);
    }
  }
}
function AglEditorAce$init_$lambda(this$0) {
  return function (_anonymous_parameter_0__qggqh8) {
    update(this$0);
    return Unit_getInstance();
  };
}
function AglEditorAce$init_$lambda_0(this$0) {
  return function (entries) {
    onResize(this$0, entries);
    return Unit_getInstance();
  };
}
function AglEditorAce$update$lambda(this$0) {
  return function () {
    this$0.workerTokenizer.acceptingTokens = true;
    this$0.processSentence();
    return Unit_getInstance();
  };
}
//region block: post-declaration
setMetadataFor(BuildConfig_0, 'BuildConfig', objectMeta);
setMetadataFor(AglCodeCompleter, 'AglCodeCompleter', classMeta);
setMetadataFor(AglCodeCompleterByWorker, 'AglCodeCompleterByWorker', classMeta);
setMetadataFor(AglErrorAnnotation, 'AglErrorAnnotation', classMeta);
setMetadataFor(IAce, 'IAce', interfaceMeta);
setMetadataFor(AglEditorAce, 'AglEditorAce', classMeta);
setMetadataFor(AglLineStateAce, 'AglLineStateAce', classMeta);
setMetadataFor(AglTokenAce, 'AglTokenAce', classMeta);
setMetadataFor(AglLineTokensAce, 'AglLineTokensAce', classMeta);
setMetadataFor(AglTokenizerAce, 'AglTokenizerAce', classMeta);
setMetadataFor(AglTokenizerByWorkerAce, 'AglTokenizerByWorkerAce', classMeta, VOID, [AglTokenizerByWorker]);
//endregion
//region block: exports
var BuildConfig = {getInstance: BuildConfig_getInstance};
export {
  BuildConfig,
  AglCodeCompleter,
  AglCodeCompleterByWorker,
  AglErrorAnnotation,
  attachToAce,
  AglLineStateAce,
  AglTokenAce,
  AglLineTokensAce,
  AglTokenizerAce,
  AglTokenizerByWorkerAce,
};
export {
  IAce as a,
  attachToAce as b,
};
//endregion

//# sourceMappingURL=net.akehurst.language.editor-agl-editor-browser-ace.mjs.map
